import { getData } from "../utils/storeData";
import axios from "./instance";

export const getWorlds = (user, token) => {
  return axios({
    url: `/worlds`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    params: {
      user,
    },
  }).then((res) => res);
};

export const setScore = (_, worldType, score, time) => {
  const token = getData("tt");
  return axios({
    url: `/worlds/score`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      worldType,
      score,
      time,
    },
  }).then((res) => res);
};

export const unlockWorld = (_, worldType) => {
  const token = getData("tt");
  return axios({
    url: `/worlds/status`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      worldType,
      active: true,
    },
  }).then((res) => res);
};
